<template>
  <div id="dropdown_user" class="dropdown-content">
    <div class="container">
      <div class="row center black-text">
        <br />
        <h5 class="mb-0">{{ user_name }}</h5>
        <p class="mt-0">{{ user_email }}</p>
      </div>
      <div class="block-menu">
        <div class="row center">
          <a href="/home/inicio" class="col m4 active">
            <i class="material-icons">home</i>Início
          </a>
          <a href="/home/nova-simulacao" class="col m4">
            <i class="material-icons">add</i>Nova simulação
          </a>
          <a href="/home/minhas-simulacoes" class="col m4">
            <i class="material-icons">folder</i>Minhas simulações
          </a>
        </div>
        <div class="row center">
          <a href="#!" class="col m4">
            <i class="material-icons">edit</i>Editar simulações
          </a>
          <a href="#!" class="col m4">
            <i class="material-icons">settings</i>Configurações
          </a>
          <a href="#!" class="col m4">
            <i class="material-icons">add_to_home_screen</i>Instalar app
          </a>
        </div>
        <div class="divider"></div>
        <br />
        <div class="row center">
          <a href="#!" class="col m4">
            <i class="material-icons">help</i>Ajuda
          </a>
          <a href="#!" class="col m4">
            <i class="material-icons">contact_support</i>Suporte
          </a>
          <a href="/logout" @click="sair" class="col m4">
            <i class="material-icons">logout</i>Sair
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
export default {
  name: "DropdownMenuContent",
  props: {},
  data() {
    let user = firebase.auth().currentUser;
    return {
      user_name: user.displayName,
      user_email: user.email
    };
  },
  methods: {
    sair: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
  }
  }
};
</script>